import useGetTechnologies from './useGetTechnologies'

export default useGetTechnologies
